export default "__VITE_ASSET__BLEQfV6D__"